iScreenWizard.controller('NieuwsbrievenController', function ($scope, $state, $mdDialog, Ajax, Dictionary, WizardContent, userService) {

    $scope.content = '';
    $scope.user = userService.model;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        refresh();
    });

    var refresh = function() {
        WizardContent.nieuwsbrieven().then(function (nieuwsbrieven) {
            $scope.content = nieuwsbrieven.inhoud;
        });
    };

});